(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { SPACE } from "../../constants/style";
import Flex from "./Flex.js";
var StyledFlex = styled(Flex).withConfig({
  displayName: "Column__StyledFlex",
  componentId: "sc-1q0mpfe-0"
})(["overflow:", ";padding:0 ", ";&:first-child{padding-left:0;}&:last-child{padding-right:0;}", ""], function (props) {
  return props.overflow;
}, function (props) {
  return SPACE[props.spacing];
}, function (props) {
  return props.left && 'margin-right: auto;';
});

var Column = function Column(props) {
  var children = props.children,
      rest = _objectWithoutProperties(props, ["children"]);

  return React.createElement(StyledFlex, rest, children);
};

Column.defaultProps = {
  direction: 'column',
  flex: '1',
  spacing: 'sm' // overflow: 'hidden',

};
Column.propTypes = {
  direction: PropTypes.oneOf(['column', 'row']),
  flex: PropTypes.string,
  spacing: PropTypes.oneOf(Object.keys(SPACE))
};
var _default = Column;
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(StyledFlex, "StyledFlex", "/home/vsts/work/1/s/src/components/layout/Column.js");
  reactHotLoader.register(Column, "Column", "/home/vsts/work/1/s/src/components/layout/Column.js");
  reactHotLoader.register(_default, "default", "/home/vsts/work/1/s/src/components/layout/Column.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();